export const URL = {
  TSME_PART: {
    MODE_PAIEMENT:
      '/mon-compte-en-ligne/mon-mode-de-paiement?payment_mode=prelevement&_reference='
  }
} as const;
